export default {
    accountType: {
        business: '事業内容',
        enterprise: 'エンタープライズ',
        label: 'アカウントの種類',
        personal: '個人',
    },
    agreeRequired: '同意する必要があります',
    email: 'メールアドレス',
    employeesMoreThanZero: '従業員数が0名以上であること',
    food: {
        donuts: 'ドーナツ',
        label: '好物',
        pasta: 'パスタ',
        pizza: 'ピザ',
        ramen: 'ラーメン',
        select: '好きな食べ物を選ぶ',
        sushi: '寿司',
        tempura: '天ぷら',
    },
    information: {
        message:
            '確渡ざびンに技油ム企詳とぱ矢強ハ援代うぱやち子載ぞふ求取ち函聞っおもう能掲ナソ修面ヒ単根ユレラ火消な庫周塚りぼ害美修級へリわべ。5江っむじぶ分棋ユ宮再21勝協電61索あトざも訟知シコエフ人取イヒ史夫体ソヌモ総確ヤモツケ行組作づの事話実ノトセ物見ーだされ末35申幻序梅まちつば。坊ねと懸百ウオモ山申エヱユコ独八覚フ竹動ょりとイ断達初リ史際メ由必がスて同98山タナ崎本もぶ断督んフひわ。',
        title: '拓好ヨモ美何アコ新刊ヱアノソ',
    },
    notifications: 'お知らせ',
    passwordConfirmationRequired: 'パスワードの確認が必要です',
    passwordMismatch: 'パスワードが一致しない',
    phone: '電話番号',
    select: '選択',
    sideDishes: {
        frenchFries: 'フライドポテト',
        label: 'お気に入りのサイドディッシュ',
        salad: 'サラダ',
        select: '好きなおかずを選ぶ',
    },
    subscription: {
        label: '購読申し込み',
        lifetime: '生活時間',
        monthly: '月次',
        yearly: '年間',
    },
};
